/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Interaction from 'astro/server/interaction';
import PlatformZone from 'astro/server/zone/platform';

import ParentEnum from 'astro/enum/parent';

import * as Shapes from 'shared/geo/shapes';


export default class extends Interaction
{
  installTargetPlanet (planet)
  {
    const target = planet.getZones().getOne(this.cass.target.id);

    target.getAttributes().setPlatformSource(this.cass.source);

    /*for (const coordinate of Shapes.getCoords(this.cass.target.id, this.cass.shape))
    {
      const location = { id: coordinate.toString(), parent: { id: planet.getID(), type: ParentEnum.Planet } };

      const zone = new PlatformZone(location, this.cass.user, planet);

      planet.getZones().insertZone(zone);
      planet.getZones().insertPlatform(zone);
    }*/
  }


  // TODO not sure this is still needed...
  installSourcePlanet (planet)
  {
    const gate = planet.getEntities().getEntity(this.cass.source.id.toString());

    for (const coordinate of Shapes.getCoords(this.cass.target.id, this.cass.shape))
    {
      gate.installPlatformCoords(coordinate);
    }
  }


};
